import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

const faqs = [
  { q: 'Typical project timeline?',   a: 'Most apps launch within 8–12 weeks.' },
  { q: 'Post-launch support?',        a: 'Yes—monitoring & maintenance packages.' },
  { q: 'Pricing models?',             a: 'Fixed-price and time-&-materials.' },
];

export default function FAQSection() {
  return (
    <Container sx={{ py: 8 }}>
      <Typography variant="h4" align="center" gutterBottom>
        FAQ
      </Typography>
      {faqs.map((f, i) => (
        <Box key={i} sx={{ mb: 3 }}>
          <Typography fontWeight={600}>{f.q}</Typography>
          <Typography color="text.secondary">{f.a}</Typography>
          {i < faqs.length - 1 && <Divider sx={{ my: 2 }} />}
        </Box>
      ))}
    </Container>
  );
}
